import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDistortion: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="distortion, liquid, material"><rect x="3.75" y="3.75" width="16.5" height="16.5" stroke="currentColor" strokeWidth="1.5"/><path d="M12 4C17.1962 10.9347 6.80385 13.0653 12 20" stroke="currentColor" strokeWidth="1.5"/><path d="M4 12C10.9347 6.80385 13.0653 17.1962 20 12" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconDistortion;
